/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ngb-typeahead-window.dropdown-menu{max-height:190px!important;overflow-y:auto;width:300px}  ngb-typeahead-window.dropdown-menu .dropdown-item{box-sizing:border-box!important;white-space:normal}input.ng-invalid[_ngcontent-%COMP%]{border:1px solid #ff6000}"];
export { styles as styles };
//# sourceMappingURL=typeahead-dropdown.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/typeahead-dropdown/typeahead-dropdown.component.scss.shim.ngstyle.js
// module id = 1355
// module chunks = 26 27 28